import { render, staticRenderFns } from "./form-audit.vue?vue&type=template&id=5d369ca5&scoped=true&"
import script from "./form-audit.vue?vue&type=script&lang=js&"
export * from "./form-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d369ca5",
  null
  
)

export default component.exports